webpackJsonp([111930841657428],{

/***/ 365:
/***/ (function(module, exports) {

	module.exports = [{"name":"GasClic","description":"GasClic is a personal project focused on helping drivers quickly find and compare fuel prices across multiple countries through a fast, modern, and map-driven experience.\n\nThe platform aggregates fuel station and pricing data to provide real-time insights for gasoline, diesel, and alternative fuels, allowing users to discover the cheapest nearby stations, plan trips more efficiently, and save money on fuel costs.\n\nBuilt with a strong emphasis on performance, usability, and clean design, GasClic combines interactive mapping technologies with custom dark-themed cartography inspired by modern navigation apps. The project also explores geospatial data visualization, large-scale map rendering, localization, and multi-country data integration.","url":"https://www.gasclic.com"},{"name":"WePlay","description":"is a digital platform that helps tennis and padel clubs modernize the way they organize competitions and engage their communities. The platform simplifies the management of internal leagues, rankings, tournaments, match scheduling, and player communication through an intuitive all-in-one system designed for clubs, federations, and players.\n\nBy automating administrative tasks and creating a more connected player experience, WePlay helps clubs increase participation, improve retention, and strengthen their sports communities. Players can easily organize matches, track their progress through rankings and statistics, and stay actively involved in club competitions, turning traditional leagues into dynamic and social sporting experiences.","url":"https://www.getweplay.com"},{"name":"Sad Trombone for iOS","description":"Someone in the house tell a bad joke? Want to annoy your partner?\n\nHit them with a perfectly timed sad trombone sound effect! You know the one, Wah Wah Wah Wah! Just like in the cartoons and movies!\n\nSad Trombone is a one trick pony. Perfect for every occasion.","url":"https://www.sadtrombone.fun/"},{"name":"NewStore","description":"NewStore transforms brick and mortar shopping into app-powered, digitally connected retail experiences. Purpose built for the most demanding consumers, NewStore is the first to provide Omnichannel-as-a Service, integrating a cloud-based order management system and Mobile POS. With intuitive apps on the front-end for store employees and pre-built ecommerce connectors, retailers can easily offer Endless Aisle, Mobile Checkout, Omni Fulfillment, and Clienteling. NewStore was founded by Stephan Schambach, who revolutionized ecommerce by putting it in the cloud with Demandware (now Salesforce Commerce Cloud). The company is located in Boston, New York, and Berlin.","url":"https://www.newstore.com"},{"name":"Klarna","description":"Klarna was founded in 2005 in Stockholm, Sweden with the aim of making it easier for people to shop online. In the last 12 years, technology has evolved, excited and transformed the world around us, yet our mission remains as relevant as ever, to make paying as simple, safe and above all, smooth as possible.\nKlarna is now one of Europe’s largest banks and is providing payment solutions for 60 million consumers across 89,000 merchants in 14 countries. Klarna offers direct payments, pay after delivery options and installment plans in a smooth one-click purchase experience that lets consumers pay when and how they prefer to.","url":"https://www.klarna.com"},{"name":"pulitzer.io","description":"The first open API for fake news detection powered by deep learning.","url":"https://pulitzer.io"},{"name":"Ovum Forecaster","description":"Better strategic decision-making with a complete view of the converging TMT market.\nForecaster provides a single point of access to the most reliable in-depth market forecast data, including comprehensive market data at the global, regional, and country level, as well as views by technology, company, and other critical metrics.","url":"https://www.youtube.com/watch?v=7SS-aqPnjqc"},{"name":"botlang","description":"A scripting language for conversational chat bots\nThe purpose of the botlang project is to design a simple, non-complex and user friendly comprehensive scripting language to enable non technical personnel in an organization to be able to implement and maintain chatbots, smart FAQ systems etc. Companies using the language benefit from rapid application time and therefore have the ability to reduce potential development costs for such system compared to a traditional approach.","status":"live","url":"https://botlang.org"},{"name":"Riseproject","description":"Rise Project identifies, develops and markets online customer acquisiton portals. We couple proprietary technology tools with highly skilled campaign managers to generate high value traffic for our customers.","url":"https://www.riseproject.com"},{"name":"tronalddump.io","description":"Api & web archive for the dumbest things Donald Trump has ever said.","status":"live","url":"https://www.tronalddump.io"},{"name":"Pocket High Street","description":"Click & collect and 1 hour delivery for London's independent local retailers.","url":"https://www.pockethighstreet.com"},{"name":"SaveTheHighStreet","description":"SaveTheHighStreet.org is powered by independent shopkeepers on a Retailer Advisory Board, industry partners across public and private sector and local high street champions nationwide.","url":"https://www.savethehighstreet.org"},{"name":"programmingtalks.org","description":"An unopinionated, curated list of the best programming talks on the Internet.","status":"live","url":"https://www.programmingtalks.org"},{"name":"chucknorris.io","description":"chucknorris.io is a free JSON API for hand curated Chuck Norris facts which also integrates with slack.com.","status":"live","url":"https://api.chucknorris.io"},{"name":"tripninjaz.com","description":"tripninjaz.com is a web application that lets users virtually explore different destinations around the world. Depending on the destination, the web application supplies pictures and information on the historical background, significance, popularity, and more.","status":"offline","url":null},{"name":"hotelsheepr.com","description":"Find & book cheap hotels - Hotelsheepr is a price comparison service for hotels. The applicatione searches all major accommodation websites for their best rates and lets users book rooms with just a few clicks.","status":"offline","url":null}]

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _gatsbyLink = __webpack_require__(72);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _projects = __webpack_require__(365);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	var _typography = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProjectList = function (_React$Component) {
	  _inherits(ProjectList, _React$Component);
	
	  function ProjectList() {
	    _classCallCheck(this, ProjectList);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ProjectList.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { style: { marginBottom: (0, _typography.rhythm)(2.5) } },
	      _projects2.default.map(function (project) {
	        var link = project.url ? _react2.default.createElement(
	          'a',
	          { style: { boxShadow: 'none' }, target: '_blank', href: project.url },
	          '[link]'
	        ) : null;
	
	        return _react2.default.createElement(
	          'div',
	          { key: project.name },
	          _react2.default.createElement(
	            'h3',
	            { style: { marginBottom: (0, _typography.rhythm)(0.5) } },
	            project.name,
	            ' ',
	            link
	          ),
	          project.description.split('\n').map(function (paragraph, key) {
	            return _react2.default.createElement(
	              'p',
	              { key: key },
	              paragraph
	            );
	          })
	        );
	      })
	    );
	  };
	
	  return ProjectList;
	}(_react2.default.Component);
	
	exports.default = ProjectList;
	module.exports = exports['default'];

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _projectList = __webpack_require__(206);
	
	var _projectList2 = _interopRequireDefault(_projectList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Project = function (_React$Component) {
	  _inherits(Project, _React$Component);
	
	  function Project() {
	    _classCallCheck(this, Project);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Project.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: 'Projects' }),
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Projects'
	      ),
	      _react2.default.createElement(_projectList2.default, null)
	    );
	  };
	
	  return Project;
	}(_react2.default.Component);
	
	exports.default = Project;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-project-js-fcefbe98aa91ce2a8084.js